import styled from 'styled-components';


export const Footer = styled.footer`
    width: 100%;
    max-width: 690px;
    margin: 0 auto;
    padding: 15px 0;
    border-top: 1px solid #eaeaea;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;

    p {
      width: 100%;
      font-size: 60%;
      text-align: center;
      justify-content: center;
      padding: 0;
      margin: 0;
    }
`
